
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/products/[product]",
      function () {
        return require("private-next-pages/[brand]/products/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/products/[product]"])
      });
    }
  